import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { UserProfile as Profile } from "oidc-client-ts"
import { accessToken } from "./accessToken"

export type AccessToken = string | undefined | null;

export interface AccessTokenState {
    accessToken: AccessToken
    idToken: Profile | null
}

const initialState: AccessTokenState = {
    accessToken: accessToken.getAccessToken(),
    idToken: null,
}

export const tokenSlice = createSlice({
    name: "token",
    initialState,
    reducers: {
        accessTokenStored: (state, action: PayloadAction<AccessToken>) => {
            state.accessToken = action.payload
        },
        idTokenStored: (state, action: PayloadAction<Profile>) => {
            state.idToken = action.payload
        },
    },
})
